const easing = 'easeInOutQuad';
const animSpeed = 400;
const globalContext = {
    messageTimeout: null
};

export { easing, animSpeed, globalContext }